import { Separator as ChakraSeparator } from "@chakra-ui/react"
import * as React from "react"

export interface SeparatorProps extends React.ComponentPropsWithoutRef<"hr"> {
  orientation?: "horizontal" | "vertical"
}

export const Separator = React.forwardRef<HTMLHRElement, SeparatorProps>(
  function Separator(props, ref) {
    return <ChakraSeparator ref={ref} {...props} />
  },
) 